export const applyFormFieldInteraction = (fieldName?: string, fieldValue = '') => {
  if (fieldName) {
    return {
      'data-event': 'Form Field Interaction',
      'data-form-field-name': fieldName,
      'data-form-field-value': fieldValue,
    };
  } else {
    return {};
  }
};
